import { Stack, styled } from '@mui/material'
import ExpiringCertifications from './components/certifications/ExpiringCertifications'
import TraineesList from './components/trainees/TraineesList'

/**
 * TraineesManagement
 * @constructor
 */
const TraineesManagement = () => {
	return (
		<Container>
			<ExpiringCertifications />
			<TraineesList />
		</Container>
	)
}

const Container = styled(Stack)({
	columnGap: '20px',
	flex: 1,
	flexDirection: 'row',
	minHeight: 0
})

export default TraineesManagement
